import React, { useCallback } from 'react';
import Video from "../main/Video";
import BackButton from '../main/BackButton';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from '../../axios-backend'

const CollectionsVideo = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const [videos, setVideos] = React.useState('')

    // Get gender from query parameter, default to '0' (women) if not provided
    const gender = searchParams.get('gender') || '0';

    const getData = useCallback(() => {
        axios.get('/get-pro-related-video', {
            params: {
                id, gender
            }
        }).then((data) => {
            if (data.data.video) {
                setVideos(data.data.video)
            }
        })
    }, [id, gender])

    React.useEffect(() => {
        getData()
    }, [getData])

    return (
        <>
            <BackButton url='/home' />
            <Video url={`${videos}`} maxHeight="80%" />
        </>
    );
}

export default CollectionsVideo;